import _omit from "lodash/omit";
import _uniqueId from "lodash/uniqueId";
import _isFunction from "lodash/isFunction";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.string.small.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.assign.js";
import React, { useState, forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
import moment from 'moment';
import { DateRangePicker, SingleDatePicker, isInclusivelyBeforeDay, isInclusivelyAfterDay } from 'react-dates';
import { Icon } from '../Icon';
import { datePickerContainer, labelStyles } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var propsToOmit = ['width', 'noFuture', 'onChange', 'label', 'showClear', 'single', 'startDate', 'minDate', 'maxDate', 'displayFormat'];
var RangePicker = /*#__PURE__*/forwardRef(function (props, reference) {
  var _props$startDate = props.startDate,
      startDateProp = _props$startDate === void 0 ? null : _props$startDate,
      _props$endDate = props.endDate,
      endDateProp = _props$endDate === void 0 ? null : _props$endDate,
      onChange = props.onChange,
      single = props.single,
      _props$noFuture = props.noFuture,
      noFuture = _props$noFuture === void 0 ? true : _props$noFuture,
      _props$small = props.small,
      small = _props$small === void 0 ? true : _props$small,
      _props$daySize = props.daySize,
      daySize = _props$daySize === void 0 ? 30 : _props$daySize,
      _props$numberOfMonths = props.numberOfMonths,
      numberOfMonths = _props$numberOfMonths === void 0 ? 1 : _props$numberOfMonths,
      minDate = props.minDate,
      maxDate = props.maxDate,
      label = props.label,
      _props$showClear = props.showClear,
      showClear = _props$showClear === void 0 ? true : _props$showClear,
      _props$displayFormat = props.displayFormat,
      displayFormat = _props$displayFormat === void 0 ? 'DD/MM/YYYY' : _props$displayFormat;
  var startDate = startDateProp ? moment.isMoment(startDateProp) ? startDateProp : moment(startDateProp) : null;
  var endDate = endDateProp ? moment.isMoment(endDateProp) ? endDateProp : moment(endDateProp) : null;

  var _useState = useState({
    startDate: startDate,
    endDate: endDate
  }),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      focusedInput = _useState4[0],
      setFocusedInput = _useState4[1];

  useImperativeHandle(reference, function () {
    return {
      clearDates: clearDates
    };
  });

  var handleDatesChange = function handleDatesChange(newDates) {
    var _newDates$startDate, _newDates$endDate;

    setValue(newDates);
    _isFunction(onChange) && (newDates === null || newDates === void 0 ? void 0 : newDates.startDate) && (newDates === null || newDates === void 0 ? void 0 : newDates.endDate) && onChange({
      startDate: (_newDates$startDate = newDates.startDate) === null || _newDates$startDate === void 0 ? void 0 : _newDates$startDate.format('YYYY-MM-DD'),
      endDate: (_newDates$endDate = newDates.endDate) === null || _newDates$endDate === void 0 ? void 0 : _newDates$endDate.format('YYYY-MM-DD')
    });
  };

  var handleDateChange = function handleDateChange(newDate) {
    setValue({
      startDate: newDate,
      endDate: null
    });
    _isFunction(onChange) && newDate && onChange(newDate.format('YYYY-MM-DD'));
  };

  var clearDates = function clearDates() {
    if (!value.startDate && !value.endDate) return;
    var emptyDates = {
      startDate: null,
      endDate: null
    };
    setValue(emptyDates);
    _isFunction(onChange) && onChange(single ? null : emptyDates);
  };

  var checkIsOutsideRange = function checkIsOutsideRange(day) {
    switch (true) {
      case noFuture && !isInclusivelyBeforeDay(day, moment()):
        return true;

      case minDate && !isInclusivelyAfterDay(day, minDate):
        return true;

      case maxDate && !isInclusivelyBeforeDay(day, maxDate):
        return true;

      default:
        return false;
    }
  };

  return ___EmotionJSX("div", {
    css: datePickerContainer(props)
  }, !!label && ___EmotionJSX("label", {
    css: labelStyles
  }, label), single ? ___EmotionJSX(SingleDatePicker, _extends({
    small: small,
    placeholder: displayFormat,
    daySize: daySize,
    numberOfMonths: numberOfMonths
  }, _omit(props, propsToOmit), {
    date: value.startDate,
    id: _uniqueId(),
    onDateChange: handleDateChange,
    focused: focusedInput === null || focusedInput === void 0 ? void 0 : focusedInput.focused,
    onFocusChange: setFocusedInput,
    isOutsideRange: checkIsOutsideRange,
    displayFormat: displayFormat
  })) : ___EmotionJSX(DateRangePicker, _extends({
    small: small,
    daySize: daySize,
    numberOfMonths: numberOfMonths
  }, _omit(props, propsToOmit), {
    startDate: value.startDate,
    startDateId: _uniqueId(),
    endDate: value.endDate,
    endDateId: _uniqueId(),
    onDatesChange: handleDatesChange,
    focusedInput: focusedInput,
    onFocusChange: setFocusedInput,
    isOutsideRange: checkIsOutsideRange,
    displayFormat: displayFormat
  })), !!showClear && ___EmotionJSX("div", {
    className: "clearIcon"
  }, ___EmotionJSX(Icon, {
    size: 22,
    iconName: "la la-close",
    color: "gray",
    onClick: clearDates
  })));
});
RangePicker.propTypes = {
  startDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  endDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onChange: PropTypes.func,
  single: PropTypes.bool,
  noFuture: PropTypes.bool,
  small: PropTypes.bool,
  daySize: PropTypes.number,
  numberOfMonths: PropTypes.number,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
  label: PropTypes.string,
  showClear: PropTypes.bool,
  displayFormat: PropTypes.string,
  width: PropTypes.string
};
export default RangePicker;